export default {"src":"https://app.iconosquare.com/_next/static/media/Arrow-Free-Tool.c6c9c03a.svg","height":40,"width":155,"blurWidth":0,"blurHeight":0};